import { Controller } from "@hotwired/stimulus"

// Opens the "Fahrzeit überschreiben" modal for one Standort row.
//
// Its own controller rather than the shared unified-dialog one for a specific reason:
// this dialog lives INSIDE the row's Turbo Frame, so a successful save replaces the
// frame and rips the open dialog out of the DOM. That fires no `close` event, and
// unified-dialog only restores document.body.style.overflow from its close handler —
// the page would stay permanently unscrollable. Here disconnect() does the cleanup, so
// removal-while-open is safe.
//
// The dialog is found through a target, not an id, so the two responsive copies of the
// site sidebar cannot collide.
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: Boolean }

  connect() {
    // A validation failure re-renders the frame with open: true so the modal comes back
    // with its error messages instead of silently closing.
    if (this.openValue) this.open()
  }

  disconnect() {
    this.releaseBodyScroll()
  }

  open() {
    if (this.dialogTarget.open) return

    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.close()
  }

  // Native `close` event: Escape, the close button, or a programmatic close.
  handleClose() {
    this.releaseBodyScroll()
  }

  // The ::backdrop belongs to the dialog element, so a click landing on the element
  // itself (rather than any child) came from outside the panel.
  handleBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  releaseBodyScroll() {
    document.body.style.overflow = ""
  }
}
